'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinearAxisOptions = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLinearAxisOptions = exports.getLinearAxisOptions = function getLinearAxisOptions(axis, options) {
  var ticks = axis.tickValues();
  if (R.isNil(ticks) || R.isEmpty(ticks)) {
    return { min: null, max: null, step: null, pivot: null };
  }
  var domain = axis.scale().domain();
  var pivot = R.path(['linear', 'pivot', 'value'], options);
  var min = R.min.apply(R, (0, _toConsumableArray3.default)(domain));
  var max = R.max.apply(R, (0, _toConsumableArray3.default)(domain));

  var _R$take = R.take(2, ticks),
      _R$take2 = (0, _slicedToArray3.default)(_R$take, 2),
      t1 = _R$take2[0],
      t2 = _R$take2[1];

  var step = t2 - t1;
  return { min: min, max: max, step: step, pivot: pivot };
};